import React, { useState, useRef, useEffect } from "react";
import PropTypes from 'prop-types';
import { Script } from "gatsby"

const isBrowser = typeof window !== "undefined"

const getWidth = () => {
  if (isBrowser) {
    return window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  }
  return null;
}

export default function TableauBlock(
    {
        id,
        url,
        hideTabs,
        name
    }) {

	const [viz, setViz] = useState(null);
  const [width, setWidth] = useState(getWidth());
  const [vizWidth, setVizWidth] = useState();
  const [vizHeight, setVizHeight] = useState();
  const [showMobile, setShowMobile] = useState(getWidth() <= 1025);

  const vizRef = useRef(null);

  function loadViz(u, width, height) {
	setViz(
		<tableau-viz 
			ref={vizRef}
			id={id}       
			src={u}
			height={vizHeight ? vizHeight + 80 : height}
			width={vizWidth ? vizWidth + 20 : width}
			device={showMobile ? "phone" : "desktop"}
			hide-tabs={hideTabs}
			toolbar='hidden'
			>
		</tableau-viz>
	);
	}

	function setVizSize() {
		if (vizRef?.current?.workbook?.activeSheet?.size?.maxSize) {
			setVizWidth(vizRef?.current?.workbook?.activeSheet?.size?.maxSize.width);
			setVizHeight(vizRef?.current?.workbook?.activeSheet?.size?.maxSize.height);
			setShowMobile(width < vizRef?.current?.workbook?.activeSheet?.size?.maxSize.width)
		}
	}

	useEffect(() => {
		// timeoutId for debounce mechanism
		let timeoutId = null;
		const resizeListener = () => {
		  // prevent execution of previous setTimeout
		  clearTimeout(timeoutId);
		  // change width from the state object after 150 milliseconds
		  timeoutId = setTimeout(() => {
			setWidth(getWidth())
			setShowMobile(getWidth() < vizWidth)
		}, 150);
		};
		// set resize listener
		window?.addEventListener("resize", resizeListener);

		// clean up function
		return () => {
		  // remove resize listener
		  window?.removeEventListener("resize", resizeListener);
		  
		};

	  // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, []);

	  useEffect(() => {
		if (url) {
			loadViz(url);
		}
		
		if (window) {
			window.onbeforeunload = () => {
				setViz(null);
			}
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [url])

	useEffect(() => {
		let height = 1000;
		if (showMobile) {
			height = 2500;
		}
		if (url) {
			setViz(null);
			loadViz(url, width, height);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [url])

	useEffect(() => {
		if (url) {
			setViz(null);
			loadViz(url, vizWidth, vizHeight);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [url, vizWidth, vizHeight])

	useEffect(() => {
		if (viz) {
			let v = document.getElementById(id);
			v.addEventListener("firstinteractive", async (event) => {
				setVizSize();
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [viz])


  return (
	<div className={`mt-5 mb-10 ${showMobile ? 'max-w-fit overflow-x-auto overflow-y-hidden' : 'inline-block'}`} style={{marginLeft: !showMobile ? -(((vizWidth || width) - 1045)/2) : null, width: !showMobile ? vizWidth || width : null }}>
		<div className="content-center items-center w-full mt-8">
			<div className="mx-auto min-h-[600px]">{viz}</div>
		</div>
		<Script id="tableausdk" type="module" src="https://public.tableau.com/javascripts/api/tableau.embedding.3.3.0.min.js" async></Script>
	</div>
  )
}

TableauBlock.propTypes = {
	id: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
	hideTabs: PropTypes.bool,
	name: PropTypes.string
}